import type { SVGProps } from 'react';

export default function StorybookIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_4602_13484)'>
        <path
          d='M3.11263 22.0683L2.37074 2.30018C2.34623 1.64732 2.84683 1.09402 3.49888 1.05327L20.313 0.00238575C20.9767 -0.0390961 21.5484 0.465319 21.5899 1.12903C21.5914 1.15403 21.5922 1.17908 21.5922 1.20414V22.745C21.5922 23.41 21.0531 23.9491 20.3881 23.9491C20.3701 23.9491 20.3521 23.9487 20.3341 23.9479L4.26185 23.226C3.6359 23.1979 3.13613 22.6944 3.11263 22.0683Z'
          fill='#FF4785'
        />
        <mask id='mask0_4602_13484' style={{ maskType: 'luminance' }} maskUnits='userSpaceOnUse' x='2' y='0' width='20' height='24'>
          <path
            d='M3.11263 22.0683L2.37074 2.30018C2.34623 1.64732 2.84683 1.09402 3.49888 1.05327L20.313 0.00238575C20.9767 -0.0390961 21.5484 0.465319 21.5899 1.12903C21.5914 1.15403 21.5922 1.17908 21.5922 1.20414V22.745C21.5922 23.41 21.0531 23.9491 20.3881 23.9491C20.3701 23.9491 20.3521 23.9487 20.3341 23.9479L4.26185 23.226C3.6359 23.1979 3.13613 22.6944 3.11263 22.0683Z'
            fill='white'
          />
        </mask>
        <g mask='url(#mask0_4602_13484)'>
          <path
            d='M16.5642 2.94372L16.679 0.181428L18.9881 0L19.0876 2.84866C19.091 2.9478 19.0135 3.03097 18.9143 3.03444C18.8719 3.03592 18.8303 3.02231 18.7969 2.99602L17.9065 2.29455L16.8522 3.09429C16.7731 3.15424 16.6605 3.13877 16.6005 3.05974C16.5753 3.02647 16.5624 2.98544 16.5642 2.94372ZM13.6111 9.02673C13.6111 9.4952 16.7666 9.27067 17.1902 8.94161C17.1902 5.75148 15.4784 4.07512 12.3439 4.07512C9.20942 4.07512 7.45321 5.77756 7.45321 8.33123C7.45321 12.7789 13.4554 12.864 13.4554 15.29C13.4554 15.971 13.122 16.3753 12.3884 16.3753C11.4325 16.3753 11.0546 15.8871 11.099 14.2272C11.099 13.8671 7.45321 13.7549 7.34206 14.2272C7.05902 18.2497 9.56511 19.4099 12.4328 19.4099C15.2117 19.4099 17.3902 17.9288 17.3902 15.2474C17.3902 10.4806 11.2991 10.6083 11.2991 8.24611C11.2991 7.28848 12.0105 7.1608 12.4328 7.1608C12.8775 7.1608 13.6777 7.23917 13.6111 9.02673Z'
            fill='white'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_4602_13484'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}

StorybookIcon.displayName = 'StorybookIcon';
